import { Auth } from '@jg/auth';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IAppState } from '../../types/state.d';
import { getSelectedFundraisingPage } from '../../selectors/appSelectors';
import linkFundraisingPage from './linkFundraisingPage';
import pushToPage from './pushToPage';
import { ROUTES } from '../../consts';

const linkSelectedFundraisingPage = () => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
) => {
  const state = getState();
  const frpId = getSelectedFundraisingPage(state) as string;
  await dispatch(linkFundraisingPage(frpId));
  dispatch(pushToPage(ROUTES.YOU_ARE_IN_THE_TEAM));
};

export default linkSelectedFundraisingPage;
